import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "course-grid" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "course-icon" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CoursesView',
  setup(__props) {

const courses = [
  {
    title: 'Intro to Computers',
    icon: '🖥️',
    description: 'Learn the fundamentals of how computers work, from hardware to operating systems. A great starting point for new students.',
    url: 'https://spacecoaststem.gitlab.io/courses/intro-to-computers/'
  },
  {
    title: 'Intro to Coding',
    icon: '💻',
    description: 'A beginner-friendly introduction to programming concepts, designed for students with no prior experience.',
    url: 'https://spacecoaststem.gitlab.io/courses/intro-to-coding'
  }
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _cache[4] || (_cache[4] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("div", { class: "hero-content" }, [
        _createElementVNode("h2", null, "Courses"),
        _createElementVNode("p", null, "Free, self-paced curriculum developed by Space Coast STEM")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/students",
          class: "back-link"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("← Back to Student Resources", -1)
          ]))]),
          _: 1
        }),
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Explore Our Courses", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", null, "Each course is free and self-paced, with materials you can use at home or in the classroom.", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(courses, (course) => {
            return _createElementVNode("a", {
              key: course.title,
              href: course.url,
              class: "course-card",
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(course.icon), 1),
              _createElementVNode("h3", null, _toDisplayString(course.title), 1),
              _createElementVNode("p", null, _toDisplayString(course.description), 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "course-link" }, "View Course →", -1))
            ], 8, _hoisted_4)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})